exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".call-history .calls .call {\n  display: flex;\n  padding: 1rem 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12); }\n  .call-history .calls .call * {\n    margin-right: 1rem; }\n  .call-history .calls .call .details {\n    flex: 1; }\n    .call-history .calls .call .details .subscribers {\n      display: flex; }\n      .call-history .calls .call .details .subscribers .subscriber {\n        flex: 1;\n        font-weight: bold; }\n        .call-history .calls .call .details .subscribers .subscriber small {\n          font-weight: normal; }\n  .call-history .calls .call .time {\n    flex: 0 1 150px; }\n  .call-history .calls .call .redial {\n    flex: 0 1 80px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader/lib/loader.js!./styles/call-history.scss
// module id = 550
// module chunks = 0